import React from 'react';
import { cn } from '@/lib/utils';

export function SidebarAccountAvatar({
    initials,
    avatarUrl,
    avatarError,
    onAvatarError,
    imageLoaded,
    onImageLoad,
}: {
    initials: string;
    avatarUrl?: string | null;
    avatarError: boolean;
    onAvatarError: () => void;
    imageLoaded?: boolean;
    onImageLoad?: () => void;
}) {
    const fadeHeaderImage = onImageLoad != null;

    return (
        <div className="relative flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-full bg-gradient-primary">
            <span className="absolute inset-0 flex items-center justify-center text-xs font-semibold text-white" aria-hidden>
                {initials}
            </span>
            {avatarUrl && !avatarError && (
                <img
                    src={avatarUrl}
                    alt=""
                    className={cn(
                        'absolute inset-0 h-full w-full object-cover',
                        fadeHeaderImage && 'transition-opacity duration-200',
                        fadeHeaderImage && (imageLoaded ? 'opacity-100' : 'opacity-0')
                    )}
                    onLoad={onImageLoad}
                    onError={onAvatarError}
                />
            )}
        </div>
    );
}
